import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable, forkJoin } from 'rxjs';
import { MwLoadOptionsService } from 'app/services/utils/load-options.service';
import { MwLoadOptions } from 'app/models/load-options.model';
import { ProductApiModel } from '../models/product-api.model';
import { MwPayloadModel } from 'app/models/payload.model';

@Injectable()
export class MwProductApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  private apiEndpoint = '/integration/v1/Companies/{companyId}/ProductTypes';

  getProducts(
    requestModel?: MwLoadOptions
  ): Observable<MwPayloadModel<ProductApiModel[]>> {
    let query = requestModel
      ? this.loadOptionsService.buildQuery(requestModel)
      : '';
    query = query.length > 0 ? '?' + query : query;

    return this.http.authGet<MwPayloadModel<ProductApiModel[]>>(
      `${this.apiEndpoint}${query}`
    );
  }

  createProduct(product: ProductApiModel): Observable<ProductApiModel> {
    return this.http.authPost<ProductApiModel>(`${this.apiEndpoint}`, {
      body: product,
    });
  }

  updateProduct(product: ProductApiModel): Observable<ProductApiModel> {
    return this.http.authPut<ProductApiModel>(`${this.apiEndpoint}`, {
      body: product,
    });
  }

  deleteProduct(product: ProductApiModel): Observable<any> {
    return this.http.authDelete<ProductApiModel>(`${this.apiEndpoint}`, {
      body: product,
    });
  }

  deleteProductList(products: ProductApiModel[]): Observable<any> {
    return forkJoin(
      products.map((item) =>
        this.http.authDelete<ProductApiModel>(`${this.apiEndpoint}`, {
          body: item,
        })
      )
    );
  }
}
